import React from "react";
import { Col } from "antd";
import { SearchSelectDebounce } from "Components/SearchSelectDebounce/SearchSelectDebounce";
import { MyHeader } from "Components/MyHeader/MyHeader";
import { TeamOutlined } from "@ant-design/icons";
export const FormWrapper = ({
  title,
  workerType,
  description,
  customFetch,
  mode,
  onChange,
  value = [],
  disabled = false,
  lg = 8,
}) => {
  return (
    <Col xs={24} lg={lg}>
      <MyHeader
        mainTitle={title}
        level={5}
        childrenInHeader={() => (
          <SearchSelectDebounce
            disabled={disabled}
            prefix={<TeamOutlined />}
            onChange={onChange}
            type={workerType}
            customFetch={customFetch}
            mode={mode}
            value={value}
          />
        )}
        secondaryText={description}
      />
    </Col>
  );
};
